import {Component, Input, OnInit} from '@angular/core';
import {Favorite} from '@models/favorite';

@Component({
    selector: 'app-price',
    templateUrl: './price.component.html',
    styleUrls: ['./price.component.scss']
})
export class PriceComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;

    constructor() {
    }

    ngOnInit(): void {
    }

}
